const DESKTOP_BREAKPOINT = 1050;

function registerSearchPopover() {
    const header = document.querySelector('.site-header');
    const popover = document.querySelector('.site-header__search-popover');
    if (!header || !popover) {
        return;
    }

    new ResizeObserver((entries) => {
        for (const entry of entries) {
            if (entry.contentBoxSize[0].inlineSize < DESKTOP_BREAKPOINT) {
                try {
                    popover.hidePopover();
                } catch {
                    // Already closed
                }
            }
        }
    }).observe(header);
}

const { register } = window.sitchco;
register(registerSearchPopover);
